/*
 * @Description: 任务记录搜索中使用的字段与组件
 * @Date: 2021-06-24 10:32:02
 */
import TableSearch from '../components/table-search.vue';

export default {
  data() {
    return {
      searchQuery: {
        superviseStatus: 1,
        fullName: '',
        phone: '',
        userTag: ''
      }
    };
  },
  components: {
    TableSearch
  }
};
